<template>
  <div id="trends">
    <!-- 横幅图  -->
    <div class="multiple_banner" v-for="item in banners" :key="item.id" v-show="tabIndex === item.id">
      <el-image style="width: 100%;height: 219px;border:0;" :src="item.url" fit="fill">
        <div slot="error" class="image-slot">
          <el-image style="width: 100%; height: 100%; border: 0" :src="defalutUrl" fit="fill" />
        </div>
      </el-image>
    </div>
    <!--  主体内容  -->
    <div class="multiple_main">
      <div class="multiple_warp">
        <!--    主体标题    -->
        <div class="multiple_title">
          <div class="multiple_title_main">{{ tabs[tabIndex].title }}</div>
          <div class="multiple_title_path">网站首页/企业项目/{{ tabs[tabIndex].title }}</div>
        </div>
        <div class="multiple_content">
          <!--    tab切换      -->
          <div class="multiple_content_left">
            <div class="multiple_item_warp" v-for="item in tabs" :key="item.id"
                 :class="[tabIndex === item.id ? 'multipleItemWarpAction' : '']" @click="multipleTabClick(item)">
              {{ item.title }}
            </div>
          </div>
          <!--    tab切换内容      -->
          <div class="multiple_content_right">
            <div class="list_title_warp">
              <div class="list_title_txt">
                {{ tabs[tabIndex].title }}
              </div>
              <div class="list_title_null">
              </div>
            </div>
            <!--     内容数据       -->
            <div class="content_list_warp">
              <div class="list_item_warp" v-for="item in data" :key="item.id">
                <el-link @click="articleClick(item.id)" :underline="false">
                  <el-card class="box-card" shadow="hover" style="width: 100%; height: 161px;">
                    <div class="item_warp_content">
                      <div class="item_warp_left">
                        <el-image style="width:200px; height: 150px; border:0;" :src="preview+item.fileId" fit="fill">
                          <div slot="error" class="image-slot">
                            <el-image style="width: 100%; height: 100%; border: 0" :src="defalutUrl" fit="fill" />
                          </div>
                        </el-image>
                      </div>
                      <div class="item_warp_right">
                        <div class="list_item_title">{{ item.arTitle || item.itemName }}</div>
                        <div class="list_item_time">
                          {{ item.releaseTime || new Date(item.createTime).format("yyyy-MM-dd") }}
                        </div>
                        <div class="list_item_summary">{{ item.arAbstract || item.synopsis }}</div>
                      </div>
                    </div>
                  </el-card>
                </el-link>
              </div>
            </div>
            <!--    内容分页      -->
            <div class="content_pages_warp">
              <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :hide-on-single-page="true"
                  :page-size="10"
                  layout="prev, pager, next, jumper"
                  :total="total">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
Date.prototype.format = function (fmt) {
  let o = {
    "M+": this.getMonth() + 1,                 //月份
    "d+": this.getDate(),                    //日
    "h+": this.getHours(),                   //小时
    "m+": this.getMinutes(),                 //分
    "s+": this.getSeconds(),                 //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds()             //毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    }
  }
  return fmt;
}
export default {
  name: 'trends',
  data() {
    return {
      defalutUrl: require("../../public/statics/error/zwtp.jpg"),
      //横幅图
      banners: [
        {
          id: 0,
          url: "/statics/banner/project/projectBak_01.png"
        },
        {
          id: 1,
          url: "/statics/banner/project/projectBak_02.png"
        }
      ],
      //tab切换下标
      tabIndex: 0,
      //tab切换
      tabs: [
        {
          id: 0,
          title: "企业项目",
          arCatalog: "enterprise_project"
        },
        {
          id: 1,
          title: "项目成果",
          arCatalog: "project_results"
        }
      ],
      //文章类型
      arCatalog: "enterprise_project",
      //数据
      data: [],
      //总数
      total: 0
    }
  },
  watch: {
    //监听路由变化
    $route: {
      handler() {
        this.getBanners();
        this.getData(1, "enterprise_project");
        this.tabIndex = 0;
        this.arCatalog = "enterprise_project";
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    //获取横幅图
    async getBanners() {
      let banners1 = await this.request.get('/banner/getInfo?key=' + this.config.key + "&bannerType=8")
      if (banners1.data && banners1.data.fileId) {
        this.banners[0].url = this.preview + banners1.data.fileId;
      }
      let banners2 = await this.request.get('/banner/getInfo?key=' + this.config.key + "&bannerType=9")
      if (banners2.data && banners2.data.fileId) {
        this.banners[1].url = this.preview + banners2.data.fileId;
      }
    },
    //文章详情点击（包括：公司新闻、项目动态、党建专栏、项目成果、行政法规、行政动态、招标信息、中标信息）
    articleClick(id) {
      if ("project_results" === this.arCatalog) {
        this.$router.push({path: "/article", query: {"active": 4, "id": id}});
      } else {
        this.$router.push({path: "/pid", query: {"active": 4, "id": id}});
      }
    },
    //tab点击切换事件
    multipleTabClick(item) {
      this.tabIndex = item.id;
      this.arCatalog = item.arCatalog;
      this.getData(1, this.arCatalog);
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.getData(val, this.arCatalog);
    },
    //获取数据
    getData(val, arCatalog) {
      this.arCatalog = arCatalog;
      if ("project_results" === this.arCatalog) {
        this.request.get('/article/list?key=' + this.config.key + "&pageNum=" + val + "&pageSize=10&arCatalog=" + this.arCatalog).then(res => {
          this.data = res.data;
          this.total = res.total;
        });
      } else {
        this.request.get('/item/list?key=' + this.config.key + "&pageNum=" + val + "&pageSize=10").then(res => {
          this.data = res.data;
          this.total = res.total;
        });
      }
    }
  }
}
</script>
<style>
@import "../assets/styles/pages/multiple.css";
</style>
